import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { userRoles } from "@awe-web/shared/lib";
import { Translation as T } from "@awe-web/shared/lib";
import { TypeArea } from "../../../components/layout.js";
import { Row, Col } from "../../../components/grid.js";
import { Button } from "../../../components/form.js";
import { ScreenSection, ScreenHeading } from "../../../components/screen.js";
import { TextLinkList } from "../../../components/text_link_list.js";
import RequestResetPasswordTokenForm from "../../../user/components/request_reset_password_token_form";
import { B2C_Login, B2C_SignUp } from "../../../routing/routes.js";
import * as userActions from "../../../user/actions.js";
import { useInitialize } from "../../../util/react.js";

const HEADING = "FSD0000097";
const LINK_LOGIN = "FSD0000253";
const LINK_SIGN_UP = "FSD0000254";

export default function B2C_RequestResetPasswordToken() {
  const dispatch = useDispatch();

  const onSubmit = useCallback(async ({ login, captchaToken }) => {
    const isSuccess = await dispatch(userActions.requestNewPassword(login, userRoles.B2C, captchaToken));
    return isSuccess;

  }, [dispatch]);


  const init = useCallback(async () => await dispatch(userActions.initialize()), [dispatch]);
  const isReady = useInitialize(init);
  if (!isReady) {
    return null;
  }

  return (
    <div className="request-reset-password-token">
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col tablet={{ cols: 4, offset: 2 }} desktop={{ cols: 4, offset: 4 }}>
              <ScreenHeading>
                <T code={HEADING} />
              </ScreenHeading>

              <RequestResetPasswordTokenForm
                backlinkLocation={B2C_Login.path()}
                onSubmit={onSubmit}
              >
                <TextLinkList>
                  <Button tertiary to={B2C_Login.path()}>
                    <T code={LINK_LOGIN} />
                  </Button>
                  <Button tertiary to={B2C_SignUp.path()}>
                    <T code={LINK_SIGN_UP} />
                  </Button>
                </TextLinkList>
              </RequestResetPasswordTokenForm>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
